import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import blog1 from "../assets/images/blog11.png";
import blog2 from "../assets/images/blog2.jpg";
import blog3 from "../assets/images/blog2.png";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};

// 🔥 Stagger container
const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

export default function InsightsSection() {
  const articles = [
    {
      id: "working-capital-loans",
      title: "Navigating Working Capital Loans Effectively",
      date: "April 12, 2024",
      desc: "Optimize your cash flow with smart financing strategies.",
      image: blog1,
    },
    {
      id: "private-vs-bank-loans",
      title: "Private Funding vs. Bank Loans: What You Need to Know",
      date: "March 28, 2024",
      desc: "Comparing alternative finance to traditional banking.",
      image: blog2,
    },
    {
      id: "capital-markets",
      title: "Capital Markets Opportunities",
      date: "March 22, 2024",
      desc: "Strategies for growth pathways.",
      image: blog3,
    },
  ];

  const heroBlog = articles[0];

  return (
    <section>

      {/* ================= HERO TITLE ================= */}
      <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        className="text-center mb-10"
      >
        <h2 className="text-3xl font-semibold text-gray-800">
          Insights & Resources
        </h2>
        <div className="w-[300px] h-[1px] bg-gray-300 mx-auto my-3 rounded"></div>
        <p className="text-gray-500 mt-2">
          Expert Advice for Corporate Success.
        </p>
      </motion.div>

      {/* ================= HERO BLOG ================= */}
      <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        className="max-w-7xl mx-auto px-6 mb-16"
      >
        <div
          className="relative rounded-lg overflow-hidden shadow-lg h-[400px]"
          style={{
            backgroundImage: `url(${heroBlog.image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-transparent"></div>

          <div className="relative p-20 max-w-xlg text-white">
            <h3 className="text-3xl font-semibold leading-snug">
              {heroBlog.title}
            </h3>

            <div className="w-[350px] h-[1px] bg-gray-300 my-3 rounded"></div>

            <p className="text-md mt-3 text-gray-200">
              {heroBlog.desc}
            </p>

            <Link to={`/blog/${heroBlog.id}`}>
              <button className="mt-6 px-5 py-2 bg-green-500 hover:bg-green-600 text-white text-sm rounded-md transition">
                Read More →
              </button>
            </Link>
          </div>
        </div>
      </motion.div>

      {/* ================= LATEST ARTICLES ================= */}
      <div className="max-w-7xl mx-auto px-6 py-10">

        {/* Heading */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl font-semibold text-gray-800">
            Latest Articles
          </h2>
          <div className="w-[200px] h-[1px] bg-gray-300 mx-auto mt-3"></div>
        </motion.div>

        {/* 🔥 Grid with Stagger Animation */}
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3"
        >
          {articles.map((item) => (
            <Link key={item.id} to={`/blog/${item.id}`}>
              <motion.div
                variants={fadeUp}
                whileHover={{ y: -8, scale: 1.02 }}
                className="relative rounded-xl overflow-hidden shadow-md group cursor-pointer"
              >
                <div className="absolute inset-0 bg-black/50 backdrop-blur-[0.5px]"></div>

                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-56 object-cover"
                />

                <div className="absolute inset-0 bg-white/80 backdrop-blur-sm opacity-0 group-hover:opacity-75 transition duration-300"></div>

<div className="absolute inset-0 flex flex-col justify-end p-6">

  {/* 🔥 Gradient Overlay (VERY IMPORTANT) */}
  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent rounded-2xl"></div>

  {/* Content */}
  <div className="relative z-10">

    {/* Date */}
    <p className="text-xs text-gray-300 mb-1">
      {item.date}
    </p>

    {/* Title */}
    <h3 className="text-lg font-semibold text-white leading-snug">
      {item.title}
    </h3>

    {/* Description */}
    <p className="text-sm text-gray-200 mt-2 line-clamp-2">
      {item.desc}
    </p>

    {/* Button */}
    <div className="mt-4">
      <button className="inline-flex items-center gap-1 px-4 py-2 text-xs font-medium bg-[#70c037] hover:bg-[#5aa32e] text-white rounded-full transition-all duration-300 shadow-lg hover:shadow-xl">
        Read More
        <span className="text-sm">→</span>
      </button>
    </div>

  </div>
</div>
              </motion.div>
            </Link>
          ))}
        </motion.div>

        {/* Testimonial */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="text-center mt-16 text-gray-600 italic"
        >
          <p>
            “Securing funds was smooth and seamless, opening new doors for our business.”
          </p>
          <p className="mt-2 text-sm font-medium">
            — Retail Chain Owner
          </p>
        </motion.div>

      </div>
    </section>
  );
}